import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeAnalyticsData } from '@atlassian/mpac-analytics';
import { FINISH_INSTALL_APP, INSTALL_APP_ERROR } from '../../../actions/Installation/InstallApp';
import { ARI_TYPE, foldInstallableAppIdentifier } from '../../../records/InstallableAppIdentifier';
import { ANALYTICS_CATEGORY_INSTALL, AppInstalledEvent, AppInstallFailedEvent } from '../../Events';
export default function InstallAppMapper(action) {
  switch (action.type) {
    case FINISH_INSTALL_APP:
      return makeAnalyticsData({
        eventType: AppInstalledEvent,
        category: ANALYTICS_CATEGORY_INSTALL,
        actionSubjectId: foldInstallableAppIdentifier(action.installableAppId)(installableAppByKeyId => installableAppByKeyId.key, installableAppByUrlId => installableAppByUrlId.url, installableAppByARI => installableAppByARI.appKey),
        containerType: 'context',
        containerId: action.context.id,
        attributes: _objectSpread({
          suppressResultFlag: action.suppressResultFlag,
          featureFlags: action.featureFlags,
          appKey: action.appDetails.key,
          programs: action.appDetails.programs,
          paymentModel: action.appDetails.paymentModel
        }, action.installableAppId.type === ARI_TYPE && {
          isEcosystemCloudApp: true,
          ecosystemCloudAppId: action.installableAppId.ari
        })
      });
    case INSTALL_APP_ERROR:
      return makeAnalyticsData({
        eventType: AppInstallFailedEvent,
        category: ANALYTICS_CATEGORY_INSTALL,
        actionSubjectId: foldInstallableAppIdentifier(action.installableAppId)(installableAppByKeyId => installableAppByKeyId.key, installableAppByUrlId => installableAppByUrlId.url, installableAppByARI => installableAppByARI.ari),
        containerType: 'context',
        containerId: action.context.id,
        attributes: {
          errorCode: action.error.code,
          error: action.error.message,
          source: action.error.source
        }
      });
  }
}